var map = {
	"./bg/article.md": "0cb5",
	"./bg/index.md": "9409",
	"./bg/journals/JMAB/jmab.md": "c0740",
	"./bg/journals/index.md": "3368",
	"./bg/етика.md": "9937",
	"./bg/за-нас.md": "eeae",
	"./bg/инструкции.md": "daf2",
	"./bg/контакти.md": "58e8",
	"./bg/редколегия.md": "a742",
	"./bg/рецензиране.md": "ea85",
	"./bg/такси.md": "394c",
	"./en/about.md": "9e97",
	"./en/article.md": "2419",
	"./en/contacts.md": "fbc4",
	"./en/editors.md": "8136",
	"./en/ethics.md": "c90d",
	"./en/index.md": "e9f6",
	"./en/instructions.md": "d917",
	"./en/journals/JMAB/jmab.md": "aae7",
	"./en/journals/index.md": "cc41",
	"./en/peer.md": "f2ac",
	"./en/subscription.md": "ca80"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8d7b";